import { action, computed, observable, makeObservable } from 'mobx';
import {Disposers} from '../../../../../../lib/helpers';
import {MQDataPair, MQLeftSideType, MQMatchingQuestion} from '../../models';
import {MQDataPairStore} from './MQDataPairStore';
import {MQOptionsStore} from './MQOptionsStore';

export class MQEditStore {
  options: MQOptionsStore;

  @observable.shallow
  dataPairs: MQDataPairStore[];

  private readonly disposers: Disposers;

  constructor() {
    makeObservable(this);
    this.disposers = new Disposers();
    this.options = new MQOptionsStore();
    this.dataPairs = [];
    for (let count = 0; count < 5; count++)
      this.addPair();
    this.options.leftSide.addValueChangeListener(this.onLeftSideTypeChanged);
  }

  @action
  private onLeftSideTypeChanged = (value: MQLeftSideType) => {
    if (value !== 'image')
      return;
    for (let dataPair of this.dataPairs)
      dataPair.ensureLeftSideUrl();
  };

  @action
  sync = (matchingQuestion: MQMatchingQuestion) => {
    let mq = matchingQuestion;
    let optionsStore = this.options;
    this.dataPairs = [];

    optionsStore.behavior.setValue(mq.options.behavior);
    optionsStore.leftSide.setValue(mq.options.leftSide);

    for (let index = 0; index < mq.dataPairs.length; index++) {
      this.addPair();
      let dataPair = mq.dataPairs[index];
      const dataPairStore = this.dataPairs[index];
      dataPairStore.fixed.setValue(dataPair.fixed);
      dataPairStore.left.setValue(dataPair.leftContent);
      dataPairStore.right.setValue(dataPair.rightContent);
    }
  };

  @computed
  get valid(): boolean {
    for (let dataPair of this.dataPairs)
      if (
        (dataPair.left.invalid && dataPair.right.valid) ||
        (dataPair.left.valid && dataPair.right.invalid))
        return false;

    return true;
  }

  @action
  swapLeftAndRight = () => {
    for (let dataPair of this.dataPairs) {
      const tmp = dataPair.left.value;
      dataPair.left.setValue(dataPair.right.value);
      dataPair.right.setValue(tmp);
    }
  };

  @action
  addPair = () => {
    const store = new MQDataPairStore();
    this.disposers.add(store);
    this.dataPairs.push(store);
  };

  @action
  removePair = (index: number) => {
    const removed = this.dataPairs.splice(index, 1);
    removed.forEach(x => x.dispose());
  };

  @computed
  get x9Contents(): string {
    if (!this.valid)
      return '';

    const pairs: MQDataPair[] = [];

    for (let dataPair of this.dataPairs) {
      if (dataPair.left.valid && dataPair.right.valid)
        pairs.push({
          leftContent: dataPair.left.value,
          rightContent: dataPair.right.value,
          fixed: dataPair.fixed.value
        });
    }

    const result: MQMatchingQuestion = {
      options: this.options.options,
      dataPairs: pairs
    };
    return JSON.stringify(result);
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
